export default class PartnerMarketingMethod {
    public id: number;
    public name: string;
    public description: string;
}